import React from "react";
import "./Common_Banner.css";
import Breadcrumb_comp from "../breadcrumb_comp/Breadcrumb_comp";

const Common_Banner = ({ imgSrc, title_text, title_text2, breadcrumbs = [] }) => {
    return (
        <section className="Common_Banner">
            <div className="img_holder">
                <img src={imgSrc} className="banner_img" />
            </div>

            <div className="container ">
                <div className="content_div">
                    <div className="breadcrump_div">
                        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                    </div>

                    <p className="title_text">{title_text}</p>
                    <p className="title_text2">{title_text2}</p>
                </div>
            </div>

            <div className="overlay_colour"></div>
        </section>
    );
};

export default Common_Banner;
